/*
 * partials from https://github.com/turner-industries/formik-semantic-ui/blob/master/src/Form.js
 */

import React, { ReactNode } from 'react';
import {Fragment} from "react"
import hoistNonReactStatics from 'hoist-non-react-statics';
import {Formik} from 'formik';
import {Form as SemanticForm} from 'semantic-ui-react';
import {FormikConfig, FormikValues} from "formik"

interface FormikFormProps {
    className: string,
    initialValues: any,
    children: ReactNode| ((props)=>ReactNode),
    onSubmit: (values: any, formikApi: any) => void
}

class FormikForm extends React.Component<FormikFormProps> {

  render() {
    const {
      className,
      children,
      initialValues = {},
      onSubmit
    } = this.props;

    return (
      <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
        {renderProps => {
          const {
            handleSubmit,
            isSubmitting,
            errors,
            touched,
            setFieldError,
            setStatus,
            setErrors,
          } = renderProps;
          return (
            <SemanticForm onSubmit={handleSubmit} className={className} loading={isSubmitting}>
              {typeof children === 'function'
                ? children(renderProps)
                : children}
            </SemanticForm>
          );
        }}
      </Formik>
    );
  }
}

const Form = hoistNonReactStatics(FormikForm, SemanticForm);

export default Form;
